import React from "react";
import { motion } from "framer-motion";
import "./Services.css";
import SEO from "../components/SEO";

const fadeIn = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

function Process() {
  return (
    <>
      <SEO />
      <main className="services-page">
        <section className="services-hero">
          <div className="container">
            <motion.div
              initial="hidden"
              animate="visible"
              variants={fadeIn}
              className="services-hero-content"
            >
              <h1>How We Work</h1>
              <p className="hero-subtitle">
                We embed like a technical co-founder: discovery, architecture, build, and long-term
                maintenance.
              </p>
            </motion.div>
          </div>
        </section>

        <section className="process-section">
          <div className="container">
            <h2>Our Engagement Model</h2>
            <div className="process-steps">
              <div className="process-step">
                <div className="step-header">
                  <div className="step-number">1</div>
                  <h3>Discover</h3>
                </div>
                <p>
                  We learn how your business actually runs today: constraints, workflows, data,
                  and where things are breaking down. This is where we ask the hard questions.
                </p>
              </div>
              <div className="process-step">
                <div className="step-header">
                  <div className="step-number">2</div>
                  <h3>Architect</h3>
                </div>
                <p>
                  We design the system: data flows, integrations, surfaces, and failure modes.
                  You see the architecture and trade-offs before we write the first line of code.
                </p>
              </div>
              <div className="process-step">
                <div className="step-header">
                  <div className="step-number">3</div>
                  <h3>Build</h3>
                </div>
                <p>
                  We implement the infrastructure: Shopify apps, internal tools, dashboards, and
                  automations, with a bias toward clarity, testability, and long-term maintainability.
                </p>
              </div>
              <div className="process-step">
                <div className="step-header">
                  <div className="step-number">4</div>
                  <h3>Maintain</h3>
                </div>
                <p>
                  We stay involved as a long-term partner: monitoring, refining, and extending the
                  system as the business evolves instead of disappearing after launch.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="service-detail-section alt-bg">
          <div className="container">
            <h2>Built for Ownership</h2>
            <p className="service-description">
              You should not be dependent on one developer&apos;s brain or a tangle of untested
              scripts. Every engagement is structured so your team can understand, operate, and
              extend what we build.
            </p>
            <div className="service-deliverables">
              <li>Clear architecture diagrams and data-flow explanations.</li>
              <li>Readable, documented code and infrastructure decisions.</li>
              <li>Hand-off sessions so your team can confidently run the system.</li>
            </div>
          </div>
        </section>

        <section className="faq-section">
          <div className="container">
            <h2>Is This a Fit?</h2>
            <div className="faq-list">
              <div className="faq-item">
                <h3>Good fit</h3>
                <p>
                  You have a real business problem, not just a vague &quot;we need a better
                  website.&quot; You care about long-term durability, not just shipping something
                  by next week. You&apos;re comfortable with a partner who asks questions and says
                  no to the wrong work.
                </p>
              </div>
              <div className="faq-item">
                <h3>Not a fit</h3>
                <p>
                  You want quick one-off fixes, cheapest bids, or multiple vendors fighting over the
                  same codebase. You don&apos;t want to give context, just a list of tickets. In
                  those cases, a generic agency or freelancer marketplace is a better match.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="services-cta-final">
          <div className="container">
            <h2>Apply to Work With WaveTech</h2>
            <p>
              If you&apos;re looking for a long-term build partner who treats your systems like
              core infrastructure, not marketing collateral, we should talk.
            </p>
            <a href="/contact" className="cta-primary">
              Apply to Work With Us
            </a>
          </div>
        </section>
      </main>
    </>
  );
}

export default Process;

